import { Box } from '@material-ui/core';

export function TabPanel(
  props: {
    value: number;
    index: number;
  } & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
) {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ height: 'inherit', overflow: 'auto' }}
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}>
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}
